<template>
<div class="box">
  <StepTitle step-num="1" title="创建账号" />
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="orgForm">
    <el-form-item label="头像" prop="headImg">
      <el-upload
        class="avatar-uploader"
        action="#"
        :show-file-list="false"
        :on-change="onChange"
        :auto-upload="true"
        :http-request="upLoadFile"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="ruleForm.headImg" :src="ruleForm.headImg" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="账号" prop="username">
      <el-input v-model="ruleForm.username" size="small" label="描述文字" placeholder="请输入手机号"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input v-model="ruleForm.password" size="small" label="描述文字" placeholder="请输入密码"></el-input>
    </el-form-item>

    <!-- <el-form-item label="部门" prop="deptId">
      <el-select size="small" v-model="ruleForm.deptId" clearable placeholder="请选择">
        <el-option
          v-for="item in depts"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item> -->

    <el-form-item label="用户角色" prop="roleId">
      <el-select size="small" v-model="ruleForm.roleId" clearable placeholder="请选择">
        <el-option
          v-for="item in roles"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button size="small" type="primary" @click="submitForm('ruleForm')">下一步</el-button>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import StepTitle from '@/components/step-title.vue';
export default {
  components: {
    StepTitle
  },
  data() {
    return {
      showDialog: false,
      ruleForm: {
        username: "",
        password: "",
        headImg: "https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/bangzhengtest/20200919092845/5a615070bfd6469082b211748c7e9c30.png",
        // deptId: "",
        roleId: ''
      },
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        headImg: [{ required: true, message: "请选择图片", trigger: "change" }],
        // deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  mounted() {
    // 获取部门列表
    this.$store.dispatch('enum/updateDepts');
    // 获取角色列表
    this.$store.dispatch('enum/updateRoles');
  },
  computed: {
    ...mapGetters({
      depts: 'enum/depts',
      roles: 'enum/roles'
    })
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          // 保存账号信息
          this.$store.commit('user/updateAccount', this.ruleForm);
          // 下一步
          this.$emit('next');
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 改变文件
    onChange(file,fileList) {
      console.log(file, fileList);
    },
    upLoadFile(data) {
      console.log(data);
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.headImg = res.data.data.urf;
      })
    },
  },

};
</script>
<style lang="less" scoped>
@import '../../style/mixin';
.box{
  width: 500px;
  margin-top: 20px;
}
.avatar-uploader{
  height: 100px;
}
/deep/ .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .el-select{
  width: 100%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

</style>